/** @mui/material imports */
import Button from '@mui/material/Button';
import Toolbar from '@mui/material/Toolbar'; // Adds a psudo margin of the hight of the navbar
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack/Stack';
/** React imports */
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { useContext } from 'react';
/** App imports */
import { appContext } from '../Contexts/AppContext';

const Forbidden: React.FC = (): JSX.Element => {
  const { company } = useContext(appContext);
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Container className="App-header" maxWidth={false}>
      <Toolbar />
      <h1>{t('HEADING_403_PAGE_FORBIDDEN')}</h1>
      <Stack spacing={2} direction="row">
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            navigate(-1);
          }}
        >
          {t('BUTTON_BACK')}
        </Button>
        <Button
          variant="contained"
          color="primary"
          component={Link}
          to={`/${company}`}
        >
          {t('BUTTON_HOME')}
        </Button>
      </Stack>
    </Container>
  );
};

export default Forbidden;
